import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ListOrdered, LogOut, Settings, ShieldCheck } from "lucide-react";
import { useAdminAuth } from "@/state/AdminAuthContext";
import { ADMIN_NAV } from "@/constants/testIds/admin";

const navItem = (active) =>
  `inline-flex items-center gap-2 rounded-xl px-3.5 py-2 text-sm transition ring-1 ${
    active
      ? "bg-[#c79a3b]/15 text-[#e0b455] ring-[#c79a3b]/40"
      : "text-[#e8f0ec] ring-white/15 hover:bg-white/5"
  }`;

export function AdminHeader() {
  const { logout } = useAdminAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [busy, setBusy] = useState(false);

  const doLogout = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await logout();
    } finally {
      navigate("/admin/login", { replace: true });
    }
  };

  return (
    <header className="border-b border-white/10 bg-[#0b1f18]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="grid place-items-center h-9 w-9 rounded-xl bg-gradient-to-b from-[#12876a] to-[#0f3f2f] text-[#c79a3b] ring-1 ring-[#c79a3b]/40">
            <ShieldCheck strokeWidth={1.75} className="h-5 w-5" />
          </span>
          <div className="hidden sm:block">
            <p className="font-heading font-extrabold leading-none text-white">
              KadBisnes.my
            </p>
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#c79a3b]">
              Admin
            </p>
          </div>
        </div>

        <nav className="flex items-center gap-2">
          <Link
            to="/admin/orders"
            data-testid={ADMIN_NAV.ordersLink}
            className={navItem(pathname.startsWith("/admin/orders"))}
          >
            <ListOrdered strokeWidth={1.75} className="h-4 w-4" />
            <span className="hidden xs:inline sm:inline">Tempahan</span>
          </Link>
          <Link
            to="/admin/settings"
            data-testid={ADMIN_NAV.settingsLink}
            className={navItem(pathname.startsWith("/admin/settings"))}
          >
            <Settings strokeWidth={1.75} className="h-4 w-4" />
            <span className="hidden xs:inline sm:inline">Tetapan</span>
          </Link>
          <button
            type="button"
            onClick={doLogout}
            disabled={busy}
            data-testid={ADMIN_NAV.logout}
            className="inline-flex items-center gap-2 rounded-xl ring-1 ring-white/15 px-3.5 py-2 text-sm text-[#e8f0ec] hover:bg-white/5 transition disabled:opacity-60"
          >
            <LogOut strokeWidth={1.75} className="h-4 w-4" />
            <span className="hidden sm:inline">Log Keluar</span>
          </button>
        </nav>
      </div>
    </header>
  );
}
